"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactionMode = exports.FeedItemActivityType = exports.AccessRestrictionType = exports.MediaType = void 0;
const types_1 = require("@wix/ambassador-feed-v1-feed-item/types");
Object.defineProperty(exports, "MediaType", { enumerable: true, get: function () { return types_1.MediaType; } });
Object.defineProperty(exports, "AccessRestrictionType", { enumerable: true, get: function () { return types_1.Type; } });
var FeedItemActivityType;
(function (FeedItemActivityType) {
    FeedItemActivityType["DRAFT_JS"] = "DRAFTJS";
    FeedItemActivityType["RICH_CONTENT"] = "RICH_CONTENT";
    FeedItemActivityType["GROUP_COVER_CHANGED"] = "GROUP_COVER_CHANGED";
    FeedItemActivityType["ABOUT_GROUP_CHANGED"] = "ABOUT_GROUP_CHANGED";
    FeedItemActivityType["USERS_JOINED"] = "USERS_JOINED";
})(FeedItemActivityType || (exports.FeedItemActivityType = FeedItemActivityType = {}));
var types_2 = require("@wix/ambassador-reactions-v1-identity-reaction/types");
Object.defineProperty(exports, "ReactionMode", { enumerable: true, get: function () { return types_2.Mode; } });
;
;
//# sourceMappingURL=types.js.map